module.exports = __webpack_public_path__ + "stylesheets/video-folder-bottom_1683fcea734bf1c57689a8bdfaf2f93c.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/folder/video-folder-bottom.less
// module id = Cw72
// module chunks = 153